/* @flow */
/* eslint-env es6,browser */
import _scheduler from './scheduler';

/**
 * Scheduler using setTimeout
 *
 * @class _timedScheduler
 * @augments _scheduler
 */
export default class _timedScheduler extends _scheduler<?TimeoutID> {
  constructor(n: string) {
    super(n);
    this._tid = null;
  }

  _clear() {
    if (this._tid) {
      clearTimeout(this._tid);
      this._tid = null;
    }
  }

  _schedule() {
    const that = this;
    this._tid = setTimeout(() => that._processEntry(), this.delay);
  }
}
